<h1 class="text-center">Opravdu chcete akci provést?</h1>

<p *ngIf="config?.data?.msg && config?.data?.isHtml !== false" class="text-center info pb-20 pt-20 pr-15" [innerHTML]="config.data.msg"></p>

<div class="text-center">
    <gmt-button [clickAction]="onSubmit" class="pr-15">Ano</gmt-button>
    <gmt-button [clickAction]="onCancel" class="red">Ne</gmt-button>
</div>
